<template>
  <div class="zsca-qz">
    <!-- <div style="position: fixed; top: 0; left: 0; width: 100vw;"> -->
    <HomeHeader :entryList="entryList" />
    <!-- </div> -->
    <div class="main">
      <div class="left">
        <div ref="tabs" :class="['tabs', { 'is-scroll-top': isScrollTop }]">
          <ContentTab @change="onTabChange" />
          <div class="share">
            <HeadEdit icon="icon-bianji" txt="投稿/发帖" @click="handleEditor" />
          </div>
        </div>
        <!-- 3 热门文章，不显示置顶 -->
        <div v-if="tabIndex !== 3 && topList.length" class="article-top-box">
          <ArticleTop v-for="item in topList" :key="item.id" :item="item" />
        </div>
        <div class="content">
          <ArticleView v-for="item in list" :key="item.id" :item="item" />
        </div>
      </div>
      <div class="right">
        <div class="top">
          <HotQuestion @question="onQuestion" />
        </div>
        <!-- 广告组件容器 -->
        <div class="banner-box">
          <img style="max-width: 100%;" src="@/assets/zs_imgs/quyunba-bg.png" />
        </div>
        <div class="bottom">
          <NavGrid />
        </div>
      </div>
    </div>
    <!-- 提问 -->
    <QuestionAdd ref="questionAdd" :customClass="questionAddCustomClass"></QuestionAdd>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { apiContentTopList } from "@/api/contentApi";
import { apiWikiEntry } from "@/api/wikiApi";
import { debounce } from "@/plugins/util";
import { getCookies } from "@/plugins/cookies";

import mergeAsyncDataMixin from "@/mixins/mergeAsyncDataMixin";

import HeadEdit from "./components/HeadEdit";
import ContentTab from "./components/ContentTab";
import ArticleView from "./components/ArticleView";
import ArticleTop from "./components/ArticleTop";
import HotQuestion from "./components/HotQuestion";
import NavGrid from "./components/NavGrid";
import HomeHeader from "../components/homeHeader";
import QuestionAdd from "../../components/questionAdd";

export default {
  name: "ZscaQz",
  components: {
    HeadEdit,
    ContentTab,
    ArticleView,
    ArticleTop,
    HotQuestion,
    HomeHeader,
    NavGrid,
    QuestionAdd
  },
  mixins: [mergeAsyncDataMixin],
  data() {
    return {
      questionAddCustomClass: "",
      isScrollTop: true,
      tabIndex: 1,
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },

      order_by: "",
      orderList: {
        created_at: "最新发帖",
        updated_at: "最近更新",
        comment_at: "最新回复",
        default: "默认排序"
      },
      isSearch: false,
      list: [],
      topList: [],
      isSSRGetData: false,
      isScroll: false,
      timer: null,
      entryList: []
    };
  },
  async asyncData({ store, router, ssrContext, $apis }) {
    try {
      console.log("asyncData start");
      // TDK设置
      const gameInfo = store.getters.gameInfo;
      ssrContext.title = `${gameInfo.name}论坛社区_${gameInfo.name}wiki|GameKee`;
      ssrContext.keywords = `${gameInfo.name}论坛,${gameInfo.name}社区`;
      ssrContext.description = `${gameInfo.name}wiki的${gameInfo.name}论坛版块为${gameInfo.name}玩家们提供互相交流的平台，快来加入${gameInfo.name}社区吧！`;

      // const params1 = {
      //   limit: 3,
      //   type: "2"
      // };
      let pagination = {
        limit: 13,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      const params2 = {
        ...pagination,
        type: "4,17",
        order_by: "created_at",
        keyword: ""
      };
      const resList = await Promise.all([$apis.apiContentTopList(params2), $apis.apiWikiEntry()]);
      console.log(resList);

      let topList = [];
      if (resList[0].code == 0 && resList[0].data) {
        topList = resList[0].data.reduce((prev, curr) => {
          if (prev.length > 3) return prev;
          if (curr.is_top) {
            prev.push(curr);
          }
          return prev;
        }, []);
      }
      let list = [];

      if (resList[0].code == 0) {
        list = resList[0].data.slice(topList.length);
        pagination = resList[0].meta.pagination;
      }
      console.log("asyncData end");

      const entryList = resList[1].data.entry_list;

      return {
        topList,
        list,
        pagination,
        isSSRGetData: true,
        entryList
      };
    } catch (err) {
      console.log(err);
    }
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  mounted() {
    // this.setPosition();
    if (!this.isSSRGetData) {
      this.initData();
    }

    this.addScrollLoadEvent();
  },
  beforeDestroy() {
    this.removeScrollLoadEvent();
  },
  methods: {
    async initData() {
      let pagination = {
        limit: 13,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      const params2 = {
        ...pagination,
        type: "4,17",
        order_by: "created_at",
        keyword: ""
      };
      const resList = await Promise.all([apiContentTopList(params2), apiWikiEntry()]);
      console.log(resList);

      if (resList[0].code == 0 && resList[0].data) {
        this.topList = resList[0].data.reduce((prev, curr) => {
          if (prev.length > 3) return prev;
          if (curr.is_top) {
            prev.push(curr);
          }
          return prev;
        }, []);
      }

      if (resList[0].code == 0) {
        this.list = resList[0].data.slice(this.topList.length);
        pagination = resList[0].meta.pagination;
      }

      this.entryList = resList[1].data.entry_list;
    },
    addScrollLoadEvent() {
      window.addEventListener("scroll", this.onWindowScroll);
      window.addEventListener("scroll", this.onWindowScrollTop);
    },
    removeScrollLoadEvent() {
      window.removeEventListener("scroll", this.onWindowScroll);
      window.removeEventListener("scroll", this.onWindowScrollTop);
    },
    onWindowScroll: debounce(function(event) {
      const el = event.target.scrollingElement;
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 200) {
        this.pagination.page_no += 1;
        this.fetchList();
      }
    }, 200),
    onWindowScrollTop(event) {
      this.isScrollTop = event.target.scrollingElement.scrollTop < 20;
    },
    async onTabChange(index) {
      this.tabIndex = index;
      this.pagination = {
        limit: 13,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      this.list = [];
      this.topList = [];
      if (index === 1) {
        this.order_by = "created_at";
      }
      if (index === 2) {
        this.order_by = "updated_at";
      }
      if (index === 3) {
        this.order_by = "hot";
        this.pagination.limit = 10;
      }
      await this.fetchList();
    },
    onQuestion() {
      const theme = this.alias === "zsca2" ? getCookies("wikiTheme") : "";
      this.questionAddCustomClass = theme;
      this.$refs.questionAdd.open();
    },
    async fetchList() {
      const params2 = {
        ...this.pagination,
        type: "4,17",
        order_by: this.order_by,
        keyword: this.searchKeyword
      };

      const resList = await apiContentTopList(params2);

      console.log(resList);

      if (resList.code == 0 && resList.data) {
        if (this.order_by === "hot") {
          this.list = [...this.list, ...resList.data];
          return;
        }
        if (resList.meta.pagination.page_no === 1) {
          this.topList = resList.data.reduce((prev, curr) => {
            if (prev.length > 3) return prev;
            if (curr.is_top) {
              prev.push(curr);
            }
            return prev;
          }, []);
          this.list = resList.data.slice(this.topList.length);
          this.pagination = Object.assign(resList.meta.pagination, { limit: 10 });
        } else {
          this.list = [...this.list, ...resList.data];
        }
      }
    },
    handleEditor() {
      if (!this.isLoginShow("")) {
        sessionStorage.setItem("login_jump_path", `/${this.gameInfo.alias}/editor`);
        return false;
      }
      if (!this.isAuthRealName()) {
        sessionStorage.setItem("login_jump_path", `/${this.gameInfo.alias}/editor`);
        return false;
      }
      this.$router.push(`/${this.gameInfo.alias}/editor`);
    },
    setPosition() {
      /** @type {HTMLDivElement} */
      const el = this.$refs.tabs;
      const { top, left, width } = el.getBoundingClientRect();
      el.style.position = "fixed";
      el.style.width = width + "px";
      el.style.left = left + "px";
      el.style.top = top + "px";
    }
  }
};
</script>

<style lang="less" scoped>
.zsca-qz {
  padding-top: 70px;
  min-height: 100vh;
  // background: var(--zs-qz-bg-img) 50% 0px / cover no-repeat fixed;
  .main {
    display: flex;
    gap: 10px;
    width: 1216px;
    margin: 0 auto;
    min-height: 100%;
    padding: 13px 10px;
    border-radius: 12px;
    background-color: var(--zs-wiki-home-main-bg);
    .left {
      width: 0;
      flex-grow: 1;
      .tabs {
        position: sticky;
        top: 60px;
        z-index: 1;
        border-bottom: 1px solid var(--zs-qz-tabs-border-color);
        background-color: var(--zs-qz-card-bg);
        border-radius: 8px 8px 0 0;
        padding-left: 28px;
        &.is-scroll-top {
          background-color: var(--zs-qz-tabs-scroll-bg);
        }
        .share {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .article-top-box {
        background-color: var(--zs-qz-card-bg);
        line-height: 30px;
        padding: 10px 20px;
        border-bottom: 1px solid var(--zs-qz-tabs-border-color);
      }
      .content {
        background: var(--zs-qz-card-bg);
        border-radius: 0 0 8px 8px;
        padding-bottom: 20px;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      width: 356px;
      gap: 10px;
      .top {
        position: sticky;
        top: 60px;
        z-index: 1;
      }
      .banner-box {
        position: sticky;
        top: 490px;
        z-index: 1;
      }
      .bottom {
        position: sticky;
        top: 582px;
        z-index: 1;
      }
    }
  }
}
</style>
